module.exports = __webpack_public_path__ + "img/chi-1-front.34636fa4.svg";